import {
  Component,
  OnInit,
  ViewChild,
  Input,
  TemplateRef,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";

@Component({
  selector: "app-modale-info",
  templateUrl: "./modale-info.component.html",
})
export class ModaleInfoComponent implements OnInit {
  @Input()
  idBozza: string;

  @ViewChild("templateModaleInfo", { static: false })
  public modalInfo: TemplateRef<any>;
  public modalRef: BsModalRef;

  private config = {
    class: "modal-info modal-dialog modal-sm",
    animated: true,
  };
  constructor(private modalService: BsModalService) {}

  ngOnInit() {}

  public openModal() {
    this.modalRef = this.modalService.show(this.modalInfo, this.config);
  }
}
